import React from 'react';
const D8 = (props) => (
    <svg
        width={70}
        height={70}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <title>{"Combined Shape Copy 9"}</title>
        <desc>{"Created with Sketch."}</desc>
        <g
            id="Changes,-Tests,-Widgets"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        >
            <g id="Tests-History" transform="translate(-1156.000000, -1289.000000)">
                <path
                    d="M1168,1289 L1156,1289 L1156,1301 L1168,1301 L1168,1289 Z M1165,1292 L1159,1292 L1159,1293 L1165,1293 L1165,1292 Z M1159,1294 L1165,1294 L1165,1295 L1159,1295 L1159,1294 Z M1165,1296 L1159,1296 L1159,1297 L1165,1297 L1165,1296 Z"
                    id="Combined-Shape-Copy-9"
                    fill="#4B5564"
                />
            </g>
        </g>
    </svg>
);
export default D8;
